import {
  UPCOMING_BOOKINGS_LIST_START,
  UPCOMING_BOOKINGS_LIST_SUCCESS,
  UPCOMING_BOOKINGS_LIST_ERROR,
  ONGOING_BOOKINGS_LIST_START,
  ONGOING_BOOKINGS_LIST_SUCCESS,
  ONGOING_BOOKINGS_LIST_ERROR,
  COMPLETED_BOOKINGS_LIST_START,
  COMPLETED_BOOKINGS_LIST_SUCCESS,
  COMPLETED_BOOKINGS_LIST_ERROR,
  CANCELLED_BOOKINGS_LIST_START,
  CANCELLED_BOOKINGS_LIST_SUCCESS,
  CANCELLED_BOOKINGS_LIST_ERROR,
  OPERATOR_BOOKING_LIST_START,
  OPERATOR_BOOKING_LIST_ERROR,
} from "../Constant/BookingListConstants";
// const initialState = {
//     loading: false,
//     upcomingList: [
//         {
//             "bookingList": [
//                 {
//                     "trip_id": "3",
//                     "image": "",
//                     "trip_name": "New Tour",
//                     "trip_increment": "IN1234",
//                     "trip_start_date": "2021-11-29",
//                     "trip_end_date": "2021-11-30",
//                     "start_point": "Ahmedabad",
//                     "end_point": "Delhi",
//                     "max_seat": "15",
//                     "booked_bookingseat": "2",
//                     "rating": "",
//                     "payment": "",
//                     "status": "upcoming",
//                     "is_enter_otp_enable": "true",
//                     "riderList": [
//                         {
//                             "rider_id": "1",
//                             "name": "Neel Barot",
//                             "motorcycle_model_name": "Classic",
//                             "motorcycle_registration_number": "GJ01AB",
//                             "rider_mobile": "7046520086",
//                             "rider_mobile_code": "91"
//                         },
//                         {
//                             "rider_id": "2",
//                             "name": "Neel Barot",
//                             "motorcycle_model_name": "Classic",
//                             "motorcycle_registration_number": "GJ01AB",
//                             "rider_mobile": "7046520085",
//                             "rider_mobile_code": "91"
//                         },
//                         {
//                             "rider_id": "9",
//                             "name": "Neel Barot",
//                             "motorcycle_model_name": "Classic",
//                             "motorcycle_registration_number": "GJ01AB",
//                             "rider_mobile": "7046520089",
//                             "rider_mobile_code": "91"
//                         }
//                     ]
//                 }
//             ],
//             "points": {
//                 "start_point": {
//                     "0": "Ahmedabad",
//                     "2": "Manali"
//                 },
//                 "end_point": {
//                     "0": "Delhi",
//                     "2": "Leh"
//                 }
//             },
//             "count": 1,
//             "limit": "10",
//             "page": "1"
//         }
//     ],
//     ongoingList: [
//         {
//             "bookingList": [
//                 {
//                     "trip_id": "3",
//                     "image": "",
//                     "trip_name": "New Tour",
//                     "trip_increment": "IN1234",
//                     "trip_start_date": "2021-11-29",
//                     "trip_end_date": "2021-11-30",
//                     "start_point": "Ahmedabad",
//                     "end_point": "Delhi",
//                     "max_seat": "15",
//                     "booked_bookingseat": "2",
//                     "rating": "",
//                     "payment": "",
//                     "status": "upcoming",
//                     "is_enter_otp_enable": "true",
//                     "riderList": [
//                         {
//                             "rider_id": "1",
//                             "name": "Neel Barot",
//                             "motorcycle_model_name": "Classic",
//                             "motorcycle_registration_number": "GJ01AB",
//                             "rider_mobile": "7046520086",
//                             "rider_mobile_code": "91"
//                         },
//                         {
//                             "rider_id": "2",
//                             "name": "Neel Barot",
//                             "motorcycle_model_name": "Classic",
//                             "motorcycle_registration_number": "GJ01AB",
//                             "rider_mobile": "7046520085",
//                             "rider_mobile_code": "91"
//                         },
//                         {
//                             "rider_id": "9",
//                             "name": "Neel Barot",
//                             "motorcycle_model_name": "Classic",
//                             "motorcycle_registration_number": "GJ01AB",
//                             "rider_mobile": "7046520089",
//                             "rider_mobile_code": "91"
//                         }
//                     ]
//                 }
//             ],
//             "points": {
//                 "start_point": {
//                     "0": "Ahmedabad",
//                     "2": "Manali"
//                 },
//                 "end_point": {
//                     "0": "Delhi",
//                     "2": "Leh"
//                 }
//             },
//             "count": 1,
//             "limit": "10",
//             "page": "1"
//         }
//     ],
//     completedList: [
//         {
//             "bookingList": [
//                 {
//                     "trip_id": "3",
//                     "image": "",
//                     "trip_name": "New Tour",
//                     "trip_increment": "IN1234",
//                     "trip_start_date": "2021-11-29",
//                     "trip_end_date": "2021-11-30",
//                     "start_point": "Ahmedabad",
//                     "end_point": "Delhi",
//                     "max_seat": "15",
//                     "booked_bookingseat": "2",
//                     "rating": "",
//                     "payment": "",
//                     "status": "upcoming",
//                     "is_enter_otp_enable": "true",
//                     "riderList": [
//                         {
//                             "rider_id": "1",
//                             "name": "Neel Barot",
//                             "motorcycle_model_name": "Classic",
//                             "motorcycle_registration_number": "GJ01AB",
//                             "rider_mobile": "7046520086",
//                             "rider_mobile_code": "91"
//                         },
//                         {
//                             "rider_id": "2",
//                             "name": "Neel Barot",
//                             "motorcycle_model_name": "Classic",
//                             "motorcycle_registration_number": "GJ01AB",
//                             "rider_mobile": "7046520085",
//                             "rider_mobile_code": "91"
//                         },
//                         {
//                             "rider_id": "9",
//                             "name": "Neel Barot",
//                             "motorcycle_model_name": "Classic",
//                             "motorcycle_registration_number": "GJ01AB",
//                             "rider_mobile": "7046520089",
//                             "rider_mobile_code": "91"
//                         }
//                     ]
//                 }
//             ],
//             "points": {
//                 "start_point": {
//                     "0": "Ahmedabad",
//                     "2": "Manali"
//                 },
//                 "end_point": {
//                     "0": "Delhi",
//                     "2": "Leh"
//                 }
//             },
//             "count": 1,
//             "limit": "10",
//             "page": "1"
//         }
//     ],
//     cancelledList: [
//         {
//             "bookingList": [
//                 {
//                     "trip_id": "3",
//                     "image": "",
//                     "trip_name": "New Tour",
//                     "trip_increment": "IN1234",
//                     "trip_start_date": "2021-11-29",
//                     "trip_end_date": "2021-11-30",
//                     "start_point": "Ahmedabad",
//                     "end_point": "Delhi",
//                     "max_seat": "15",
//                     "booked_bookingseat": "2",
//                     "rating": "",
//                     "payment": "",
//                     "status": "upcoming",
//                     "is_enter_otp_enable": "true",
//                     "riderList": [
//                         {
//                             "rider_id": "1",
//                             "name": "Neel Barot",
//                             "motorcycle_model_name": "Classic",
//                             "motorcycle_registration_number": "GJ01AB",
//                             "rider_mobile": "7046520086",
//                             "rider_mobile_code": "91"
//                         },
//                         {
//                             "rider_id": "2",
//                             "name": "Neel Barot",
//                             "motorcycle_model_name": "Classic",
//                             "motorcycle_registration_number": "GJ01AB",
//                             "rider_mobile": "7046520085",
//                             "rider_mobile_code": "91"
//                         },
//                         {
//                             "rider_id": "9",
//                             "name": "Neel Barot",
//                             "motorcycle_model_name": "Classic",
//                             "motorcycle_registration_number": "GJ01AB",
//                             "rider_mobile": "7046520089",
//                             "rider_mobile_code": "91"
//                         }
//                     ]
//                 }
//             ],
//             "points": {
//                 "start_point": {
//                     "0": "Ahmedabad",
//                     "2": "Manali"
//                 },
//                 "end_point": {
//                     "0": "Delhi",
//                     "2": "Leh"
//                 }
//             },
//             "count": 1,
//             "limit": "10",
//             "page": "1"
//         }
//     ],
// };
const initialState = {
  loading: false,
  upcomingList: [],
  ongoingList: [],
  completedList: [],
  cancelledList: [],
};

export default function BookingListReducer(
  state = { ...initialState },
  action
) {
  switch (action.type) {
    case OPERATOR_BOOKING_LIST_START:
      return {
        ...state,
        loading: true,
      };
    case UPCOMING_BOOKINGS_LIST_START:
      return {
        ...state,
        loading: true,
      };
    case UPCOMING_BOOKINGS_LIST_SUCCESS:
      return {
        ...state,
        upcomingList: action.payload,
        loading: false,
      };
    case UPCOMING_BOOKINGS_LIST_ERROR:
      return {
        ...state,
        loading: false,
        message: action.error.message,
      };
    case ONGOING_BOOKINGS_LIST_START:
      return {
        ...state,
        loading: true,
      };
    case ONGOING_BOOKINGS_LIST_SUCCESS:
      return {
        ...state,
        ongoingList: action.payload,
        loading: false,
      };
    case ONGOING_BOOKINGS_LIST_ERROR:
      return {
        ...state,
        loading: false,
        message: action.error.message,
      };
    case COMPLETED_BOOKINGS_LIST_START:
      return {
        ...state,
        loading: true,
      };
    case COMPLETED_BOOKINGS_LIST_SUCCESS:
      return {
        ...state,
        completedList: action.payload,
        loading: false,
      };
    case COMPLETED_BOOKINGS_LIST_ERROR:
      return {
        ...state,
        loading: false,
        message: action.error.message,
      };
    case CANCELLED_BOOKINGS_LIST_START:
      return {
        ...state,
        loading: true,
      };
    case CANCELLED_BOOKINGS_LIST_SUCCESS:
      return {
        ...state,
        cancelledList: action.payload,
        loading: false,
      };
    case CANCELLED_BOOKINGS_LIST_ERROR:
      return {
        ...state,
        loading: false,
        message: action.error.message,
      };
    case OPERATOR_BOOKING_LIST_ERROR:
      return {
        ...state,
        loading: false,
        message: action.error.message,
      };
    default:
      return state;
  }
}
